/**
 * @deprecated Import from `@cornerstonejs/metadata` instead.
 */
import { Enums } from '@cornerstonejs/metadata';

export default Enums.MetadataModules;
